import { deleteTokenFromCookie } from '@/utils/cookies';

export const logoutMixin = {
  methods: {
    /**
     * 退出登录
     */
    async logout(url) {
      this.$store.commit('setToken', '');
      this.$store.commit('setUser', {});
      await this.$axios.post('/user/v1/logout');
      deleteTokenFromCookie();
      //退出的时候，清除pm的相关状态
      this.$cookies.remove('york-tim');
      location.replace(url || location.href);
    },
  },
};
